import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { addItems } from "../features/counter/counterSlice";

import tempStateMap from "../Images/Temp_State_Map.png";

//ALL STATE IMAGES
import AlabamaImage from "../Images/Alabama.png";
import AlaskaImage from "../Images/Alaska.png";
import ArizonaImage from "../Images/Arizona.png";
import ArkansasImage from "../Images/Arkansas.png";
import CaliforniaImage from "../Images/California.png";
import ColoradoImage from "../Images/Colorado.png";
import ConnecticutImage from "../Images/Connecticut.png";
import DCImage from "../Images/DC.png";
import DelewareImage from "../Images/Deleware.png";
import FloridaImage from "../Images/Florida.png";
import GeorgiaImage from "../Images/Georgia.png";
import HawaiiImage from "../Images/Hawaii.png";
import IdahoImage from "../Images/Idaho.png";
import IllinoisImage from "../Images/Illinois.png";
import IowaImage from "../Images/Iowa.png";
import IndianaImage from "../Images/Indiana.png";
import KansasImage from "../Images/Kansas.png";
import KentuckyImage from "../Images/Kentucky.png";
import LouisianaImage from "../Images/Louisiana.png";
import MaineImage from "../Images/Maine.png";
import MarylandImage from "../Images/Maryland.png";
import MassachusettsImage from "../Images/Massachusetts.png";
import MichiganImage from "../Images/Michigan.png";
import MinnesotaImage from "../Images/Minnesota.png";
import MississippiImage from "../Images/Mississippi.png";
import MissouriImage from "../Images/Missouri.png";
import MontanaImage from "../Images/Montana.png";
import NebraskaImage from "../Images/Nebraska.png";
import NevadaImage from "../Images/Nevada.png";
import NewHampshireImage from "../Images/NewHampshire.png";
import NewJerseyImage from "../Images/NewJersey.png";
import NewMexicoImage from "../Images/NewMexico.png";
import NewYorkImage from "../Images/NewYork.png";
import NorthCarolinaImage from "../Images/NorthCarolina.png";
import NorthDakotaImage from "../Images/NorthDakota.png";
import OhioImage from "../Images/Ohio.png";
import OklahomaImage from "../Images/Oklahoma.png";
import OregonImage from "../Images/Oregon.png";
import PennsylvaniaImage from "../Images/Pennsylvania.png";
import RhodeIslandImage from "../Images/RhodeIsland.png";
import SouthCarolinaImage from "../Images/SouthCarolina.png";
import SouthDakotaImage from "../Images/SouthDakota.png";
import TennesseeImage from "../Images/Tennessee.png";
import TexasImage from "../Images/Texas.png";
import UtahImage from "../Images/Utah.png";
import VermontImage from "../Images/Vermont.png";
import VirginiaImage from "../Images/Virginia.png";
import WashingtonImage from "../Images/Washington.png";
import WestVirginiaImage from "../Images/WestVirginia.png";
import WisconsinImage from "../Images/Wisconsin.png";
import WyomingImage from "../Images/Wyoming.png"; 


function StateCourseContent() {
  const [testState, setTestState] = useState(null);
  const sizeRef = useRef();

  const [, setImageHeight] = useState();
  const [hoveredState, setHoveredState] = useState(null);
  const [imageWidth, setImageWidth] = useState();
  const imageGap = 5;

  // DAVIS FUNCTIONS FOR STATE BASED CHECKOUT
  const [selectedState, setSelectedState] = useState(null);
  const handleStateClick = (stateCode) => {
    setSelectedState(stateCode);
  };

  const closeCourseBox = () => {
    setSelectedState(null);
  };

  const [selectedCourse, setSelectedCourse] = useState([]);

  const history = useNavigate();
  const dispatch = useDispatch();
  const [user] = useState(JSON.parse(localStorage.getItem("user")));

  const addItemsToBasket = (course) => {
  if (user?.email) {
    const product = {
      affiliation: course.affiliation,
      courseImg: course.crsImg,
      description: course.description,
      id: course.id,
      name: course.title || course.name,
      price: course.price,
      state: course.state,
      stateColor: course.stColor,
      stateImg: course.stImg,
      stripePromo: course.promoCodeId,
      stripePrice: course.stripePriceId,
    };
      dispatch(addItems(product));
    } else {
      history("/login");
    }
  };

  // Check if user has already been enrolled for the course
  const [ownedCourseIds, setOwnedCourseIds] = useState(() => new Set());
  const [expiredCourseIds, setExpiredCourseIds] = useState(() => new Set());

  const fetchUserCourses = async (userEmail) => {
    try {
      const res = await axios.post("/returnMyCourses", { userEmail });
      return res.data; // assuming array of courses or courseIds
    } catch (err) {
      console.error("Ownership check failed:", err);
      return [];
    }
  };


  useEffect(() => {
    const fetchOwnedCourses = async () => {
      if (!user?.email || !testState || !selectedState) return;

      const userCourses = await fetchUserCourses(user.email);
      const currentDate = new Date();

      // All owned course IDs
      const ownedSet = new Set( userCourses.map(c => c.courseId || c.id));

      // Course IDs that have at least ONE valid (non-expired) instance
      const validSet = new Set(
        userCourses
          .filter(c => !c.expiresOn || new Date(c.expiresOn) > currentDate)
          .map(c => c.courseId || c.id)
      );

      // Expired = owned but NOT valid
      const expiredSet = new Set( [...ownedSet].filter(courseId => !validSet.has(courseId)));

      setOwnedCourseIds(ownedSet);
      setExpiredCourseIds(expiredSet);
    };

    fetchOwnedCourses();
  }, [testState, selectedState, user?.email]);




  // DAVIS FUNCTIONS FOR STATE BASED CHECKOUT
  const getListSize = () => {
    const ref = sizeRef.current;
    if (!ref) return;

    const newWidth = ref.clientWidth;
    setImageWidth((newWidth - imageGap * 4) / 5);

    const newHeight = ref.clientHeight;
    setImageHeight(newHeight);
  };

  useEffect(() => {
    axios.get("/extractCourses").then((data) => {
      setTestState(data.data);
      getListSize();
    });
    window.addEventListener("resize", getListSize);
    
    return () => {
      window.removeEventListener("resize", getListSize);
      setTestState(null);
    };
  }, []);

  useEffect(() => {
    if (testState) {}
  }, [testState]);

  useEffect(() => {
    if (!selectedState) {
      setSelectedCourse(null);
    }
  }, [selectedState]);

  useEffect(() => {
    const width = sizeRef.current.offsetWidth;
    setImageWidth((width - imageGap * 4) / 5);
  }, [imageGap]);

  useEffect(() => {}, [imageWidth]);

  return (
    
    <Container>
      <Space />
      <CourseContainer ref={sizeRef}>
        {/* STATE POSITIONED UI */}
        <h1 style={{fontSize: "1.5rem", margin: "20px 0px 10px 30px" }}>UST Operator Training By State</h1>
        <CourseMapContainer>
          <MapWrapper>
            <ResponsiveImage src={tempStateMap} alt="Course Map" />
            <AlabamaIcon id="AL" src={AlabamaImage} alt="Alabama" />
            <AlaskaIcon id="AK" src={AlaskaImage} alt="Alaska" onClick={() => handleStateClick("AK")} onMouseEnter={()=> setHoveredState("Alaska")} onMouseLeave={() => setHoveredState(null)} />
            <ArizonaIcon id="AZ" src={ArizonaImage} alt="Arizona" onClick={() => handleStateClick("AZ")} onMouseEnter={()=> setHoveredState("Arizona")} onMouseLeave={() => setHoveredState(null)} />
            <ArkansasIcon id="AR" src={ArkansasImage} alt="Arkansas" />
            <CaliforniaIcon id="CA" src={CaliforniaImage} alt="CA" />
            <ColoradoIcon id="CO" src={ColoradoImage} alt="Colorado" onClick={() => handleStateClick("CO")} onMouseEnter={()=> setHoveredState("Colorado")} onMouseLeave={() => setHoveredState(null)} />
            <ConnecticutIcon id="CT" src={ConnecticutImage} alt="Connecticut" />
            <DCIcon id="DC" src={DCImage} alt="District of Columbia" onClick={() => handleStateClick("DC")} onMouseEnter={()=> setHoveredState("Washington DC")} onMouseLeave={() => setHoveredState(null)} />
            <DelewareIcon id="DE" src={DelewareImage} alt="Deleware" />
            <FloridaIcon id="FL" src={FloridaImage} alt="Florida" onClick={() => handleStateClick("FL")} onMouseEnter={()=> setHoveredState("Florida")} onMouseLeave={() => setHoveredState(null)} />
            <GeorgiaIcon id="GA" src={GeorgiaImage} alt="Georgia" />
            <HawaiiIcon id="HI" src={HawaiiImage} alt="Hawaii" />
            <IdahoIcon id="ID" src={IdahoImage} alt="Idaho" />
            <IllinoisIcon id="IL" src={IllinoisImage} alt="Illinois" onClick={() => handleStateClick("IL")} onMouseEnter={()=> setHoveredState("Illinois")} onMouseLeave={() => setHoveredState(null)} />
            <IndianaIcon id="IN" src={IndianaImage} alt="Indiana" />
            <IowaIcon id="IA" src={IowaImage} alt="Iowa" />
            <KansasIcon id="KS" src={KansasImage} alt="Kansas" />
            <KentuckyIcon id="KY" src={KentuckyImage} alt="Kentucky" />
            <LouisianaIcon id="LA" src={LouisianaImage} alt="Louisiana" />
            <MaineIcon id="ME" src={MaineImage} alt="Maine" />
            <MarylandIcon id="MD" src={MarylandImage} alt="Maryland" onClick={() => handleStateClick("MD")} onMouseEnter={()=> setHoveredState("Maryland")} onMouseLeave={() => setHoveredState(null)} />
            <MassachusettsIcon id="MA" src={MassachusettsImage} alt="Massachusetts" />
            <MichiganIcon id="MI" src={MichiganImage} alt="Michigan" onClick={() => handleStateClick("MI")} onMouseEnter={()=> setHoveredState("Michigan")} onMouseLeave={() => setHoveredState(null)} />
            <MinnesotaIcon src={MinnesotaImage} alt="Minnesota" />
            <MississippiIcon src={MississippiImage} alt="Mississippi" />
            <MissouriIcon src={MissouriImage} alt="Missouri" />
            <MontanaIcon src={MontanaImage} alt="Montana" />
            <NebraskaIcon src={NebraskaImage} alt="Nebraska" />
            <NevadaIcon src={NevadaImage} alt="Nevada" onClick={() => handleStateClick("NV")} onMouseEnter={()=> setHoveredState("Nevada")} onMouseLeave={() => setHoveredState(null)} />
            <NewHampshireIcon src={NewHampshireImage} alt="New Hampshire" />
            <NewJerseyIcon src={NewJerseyImage} alt="New Jersey" />
            <NewMexicoIcon src={NewMexicoImage} alt="New Mexico" />
            <NewYorkIcon src={NewYorkImage} alt="New York" />
            <NorthCarolinaIcon src={NorthCarolinaImage} alt="North Carolina" />
            <NorthDakotaIcon src={NorthDakotaImage} alt="North Dakota" />
            <OhioIcon id="OH" src={OhioImage} alt="Ohio" onClick={() => handleStateClick("OH")} onMouseEnter={()=> setHoveredState("Ohio")} onMouseLeave={() => setHoveredState(null)} />
            <OklahomaIcon id="OK" src={OklahomaImage} alt="Oklahoma" />
            <OregonIcon id="OR" src={OregonImage} alt="Oregon" />
            <PennsylvaniaIcon id="PA" src={PennsylvaniaImage} alt="Pennsylvania" onClick={() => handleStateClick("PA")} onMouseEnter={()=> setHoveredState("Pennsylvania")} onMouseLeave={() => setHoveredState(null)} />
            <RhodeIslandIcon id="RI" src={RhodeIslandImage} alt="Rhode Island" />
            <SouthCarolinaIcon id="SC" src={SouthCarolinaImage} alt="South Carolina" onClick={() => handleStateClick("SC")} onMouseEnter={()=> setHoveredState("South Carolina")} onMouseLeave={() => setHoveredState(null)} />
            <SouthDakotaIcon id="SD" src={SouthDakotaImage} alt="South Dakota" onClick={() => handleStateClick("SD")} onMouseEnter={()=> setHoveredState("South Dakota")} onMouseLeave={() => setHoveredState(null)} />
            <TennesseeIcon id="TN" src={TennesseeImage} alt="Tennessee" />
            <TexasIcon id="TX" src={TexasImage} alt="Texas" />
            <UtahIcon id="UT" src={UtahImage} alt="Utah" onClick={() => handleStateClick("UT")} onMouseEnter={()=> setHoveredState("Utah")} onMouseLeave={() => setHoveredState(null)} />
            <VirginiaIcon id="VA" src={VirginiaImage} alt="Virginia" onClick={() => handleStateClick("VA")} onMouseEnter={()=> setHoveredState("Virginia")} onMouseLeave={() => setHoveredState(null)} />
            <VermontIcon id="VT" src={VermontImage} alt="Vermont" />
            <WashingtonIcon id="WA" src={WashingtonImage} alt="Washington" />
            <WestVirginiaIcon id="WV" src={WestVirginiaImage} alt="West Virginia" onClick={() => handleStateClick("WV")} onMouseEnter={()=> setHoveredState("West Virgina")} onMouseLeave={() => setHoveredState(null)} />
            <WisconsinIcon id="WI" src={WisconsinImage} alt="Wisconsin" onClick={() => handleStateClick("WI")} onMouseEnter={()=> setHoveredState("Wisconsin")} onMouseLeave={() => setHoveredState(null)} />
            <WyomingIcon id="WY" src={WyomingImage} alt="Wyoming" />
            
            {/* Hovering Label Animation */}
            <StateHoverLabel $visible={!!hoveredState}>
              {hoveredState || ""}
            </StateHoverLabel>
          </MapWrapper>
        </CourseMapContainer>


        {/* STATE CHECKOUT MENU */}
        {selectedState && (
          <>
            <Backdrop onClick={closeCourseBox} />
            <CourseBox>

              <CourseBoxTitle>
                Courses for {selectedState}
                <CloseButton onClick={closeCourseBox}>✖</CloseButton>
              </CourseBoxTitle>

              <CourseBoxContent>
                {testState &&
                  testState
                    .filter(course => course.state === selectedState)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((course, index) => (
                      <CourseCheckout
                        key={index}
                        onClick={() => { setSelectedCourse(course); }} 
                        active={selectedCourse?.id === course.id}>
                        {ownedCourseIds.has(course.id) 
                          ? expiredCourseIds.has(course.id)
                            ? ( <span style={{ color: "#FF6275", fontWeight: "bold"}} >EXPIRED</span>)
                            : ( <span style={{ color: "#1e7034", fontWeight: "bold" }}>OWNED  </span>) 
                              : ( `($${course.price.toFixed(2)})` )} 
                        {" "} - {course.name}
                        <DurationText> 
                          - Est. Duration: ({course?.duration})
                          { ownedCourseIds.has(course.id) && ` - Price:  ($${course.price.toFixed(2)})`}
                        </DurationText>
                        
                      </CourseCheckout>
                    )
                  )
                }
              </CourseBoxContent>
              { (selectedCourse && user?.email && ownedCourseIds.has(selectedCourse.id) && !expiredCourseIds.has(selectedCourse.id)) &&
                <CourseBoxCheckout2  style={{ borderRadius:"0px", borderBottom:"1px solid #adadad" }}
                  onClick={() => {
                    addItemsToBasket(selectedCourse);
                    history("/basket"); }}>
                  ADD A DUPLICATE COURSE
                </CourseBoxCheckout2>
              }
              <CourseBoxCheckout
                onClick={() => {
                  // Redirect user to login page if not logged in
                  if (!user?.email) {
                    history("/login");
                    return;
                  }
                  // Alert if a course is not selected
                  if (!selectedCourse) {
                    alert("Please select a course before proceeding to checkout.");
                    return;
                  }
                  // Redirect to courses if you select one you own
                  if (ownedCourseIds.has(selectedCourse.id) && !expiredCourseIds.has(selectedCourse.id)) {
                    history("/mycourses");
                    return;
                  }
                  // Redirect to checkout if you select a course for purchase
                  addItemsToBasket(selectedCourse);
                  history("/basket");
                }}
              >
                { !user?.email 
                    ? "LOG IN..." : 
                    (ownedCourseIds.has(selectedCourse?.id) && !expiredCourseIds.has(selectedCourse.id))
                      ? "GO TO MY COURSE(S)..."
                      : "ADD TO CART & CHECKOUT"}
              </CourseBoxCheckout>
            </CourseBox>
          </>
        )}
      </CourseContainer>
      <CourseContainer>
        <h1 style={{fontSize: "1.5rem", margin: "100px 0px 20px 40px"}}>List of Offered UST Operator Trainings (shortcut)</h1>
        
        <ListedCourses>
          {testState &&
            testState
              .filter(course => course.state !== "TEST")
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((course, index) => (
                <QuickAccessCourse
                  key={index}
                  active={selectedCourse?.id === course.id}
                  onClick={() => {
                    setSelectedCourse(course);

                    setTimeout(() => {
                      const isOwned = ownedCourseIds?.has(String(course.id));

                      if (!user?.email) {
                        history("/login");
                        return;
                      }

                      if (isOwned) {
                        history("/mycourses");
                        return;
                      }

                      addItemsToBasket(course);
                      history("/basket");
                    }, 200); // 200ms delay
                  }}

                >
                  {course.name.replace(/Petroleum/g, "").replace(/ Operator -/g, "").trim()}
                </QuickAccessCourse>
            ))}
        </ListedCourses>
      </CourseContainer>
    </Container> 

  );
}

export default StateCourseContent; 

// Map Icon Elements
const CourseMapContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  width: 100vw;
  padding: 3vw 0px 2vw 0px;
  overflow: hidden;
  margin-bottom: 30px;
  user-select: none;
`;

const MapWrapper = styled.div`
  position: relative;
  width: 55vw;         /* match ResponsiveImage */
  height: auto;
`;

const StateHoverLabel = styled.div`
  position: absolute;
  top: 35%;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translateX(-50%);
  padding: 6px 12px;
  text-shadow: #FFFFFF 1px 0 20px;
  font-size: 4.0vw;
  font-weight: bold;
  color: #30B354;
  z-index: 9999;
  pointer-events: none;
  user-select: none;

  opacity: ${props => (props.$visible ? 1 : 0)};
  transition: opacity 0.5s ease;
`;

const ResponsiveImage = styled.img`
  width: 70vw;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  opacity: 0%;
`;

const StateIcon = styled.img`
  position: absolute;
  opacity: 60%; // should be 60%
  cursor: pointer;
  transform: translate(-50%, -50%) scale(1);
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    opacity: 100%;
    transform: translate(-50%, -50%) scale(1.11);
  }
`;

const HiddenStateIcon = styled.img`
  position: absolute;
  transform: translate(-50%, -50%) scale(1);
  opacity: 100%;
`;

const AlabamaIcon = styled(HiddenStateIcon)`
  left: 73.9%; top: 70.6%; width: 7.1%;
`;
const AlaskaIcon = styled(StateIcon)`
  left: -8%;  top: 78.5%;  width: 30.5%;
`;
const ArizonaIcon = styled(StateIcon)`
  left: 20.6%;  top: 60.3%;  width: 12.3%;
`;
const ArkansasIcon = styled(HiddenStateIcon)`
  left: 60.9%; top: 62.1%; width: 9.3%;
`;
const CaliforniaIcon = styled(HiddenStateIcon)`
  left: 6.7%; top: 42.9%; width: 15.5%;
`;
const ColoradoIcon = styled(StateIcon)`
  left: 34.6%;  top: 43.1%;  width: 13.45%; 
`;
const ConnecticutIcon = styled(HiddenStateIcon)`
  left: 98.7%; top: 20.1%; width: 3.4%;
`;
const DCIcon = styled(StateIcon)`
  left: 94.8%;  top: 42.5%;  width: 2.5%;
`;
const DelewareIcon = styled(HiddenStateIcon)`
  left: 93.5%;  top: 33.9%; width: 1.7%;
`;
const FloridaIcon = styled(StateIcon)`
  left: 82.2%;  top: 87.1%;  width: 16.3%;
`;
const GeorgiaIcon = styled(HiddenStateIcon)`
  left: 81.0%;  top: 68.5%;  width: 9%;
`;
const HawaiiIcon = styled(HiddenStateIcon)`
  left: 22%; top: 95%; width: 17%;
`;
const IdahoIcon = styled(HiddenStateIcon)`
  left: 19.8%; top: 13.6%; width: 10.9%;
`;
const IllinoisIcon = styled(StateIcon)`
  left: 65.8%;  top: 39.0%;  width: 7.1%;
`;
const IndianaIcon = styled(HiddenStateIcon)`
  left: 72.2%; top: 37.9%; width: 5.5%;
`;
const IowaIcon = styled(HiddenStateIcon)`
  left: 58.0%; top: 31.2%; width: 10.8%;
`;
const KansasIcon = styled(HiddenStateIcon)`
  left: 48.5%; top: 46.4%; width: 13.4%;
`;
const KentuckyIcon = styled(HiddenStateIcon)`
  left: 74.2%; top: 47.4%; width: 13.2%;
`;
const LouisianaIcon = styled(HiddenStateIcon)`
  left: 62.4%; top: 78.7%; width: 10.1%;
`;
const MaineIcon = styled(HiddenStateIcon)`
  left: 103.8%; top: 1.5%; width: 6.6%;
`;
const MarylandIcon = styled(StateIcon)`
  left: 89.9%;  top: 35.5%;  width: 7.8%;
`;
const MassachusettsIcon = styled(HiddenStateIcon)`
  left: 101%; top: 15.2%; width: 6.9%;
`;
const MichiganIcon = styled(StateIcon)`
  left: 71.3%;  top: 18.5%;  width: 13.5%;
`;
const MinnesotaIcon = styled(HiddenStateIcon)`
  left: 57.6%;  top: 13.6%;  width: 11.9%;
`;
const MississippiIcon =styled(HiddenStateIcon)`
  left: 66.7%; top: 71.3%; width: 6.4%;
`;
const MissouriIcon = styled(HiddenStateIcon)`
  left: 60.2%; top: 45.9%; width: 11.7%;
`;
const MontanaIcon = styled(HiddenStateIcon)`
  left: 29.8%; top: 7.8%; width: 18.3%;
`;
const NorthCarolinaIcon = styled(HiddenStateIcon)`
  left: 87.5%;  top: 54.4%;  width: 14.5%;
`;
const NorthDakotaIcon = styled(HiddenStateIcon)`
  left: 45.8%; top: 9.3%; width: 11.6%;
`;
const NebraskaIcon = styled(HiddenStateIcon)`
  left: 46.4%;  top: 33.3%;  width: 14.5%;
`;
const NevadaIcon = styled(StateIcon)`
  left: 13.2%;  top: 39.2%;  width: 11.8%;
`;
const NewHampshireIcon = styled(HiddenStateIcon)`
  left: 100%; top: 8.1%; width: 2.9%;
`;
const NewJerseyIcon = styled(HiddenStateIcon)`
  left: 94.5%; top: 28.8%; width: 2.5%;
`;
const NewMexicoIcon = styled(HiddenStateIcon)`
  left: 32.5%; top: 62.0%; width: 12.6%;
`;
const NewYorkIcon = styled(HiddenStateIcon)`
  left: 92.5%; top: 17.5%; width: 13%; 
`;
const OhioIcon = styled(StateIcon)`
  left: 78.7%;  top: 34.3%;  width: 7.6%;
`;
const OklahomaIcon = styled(HiddenStateIcon)`
  left: 48.1%; top: 59.9%; width: 15.5%;
`;
const OregonIcon = styled(HiddenStateIcon)`
  left: 8.3%; top: 14.8%; width: 14.3%;
`;
const PennsylvaniaIcon = styled(StateIcon)`
  left: 88.0%;  top: 28.2%;  width: 10.2%;
`;
const RhodeIslandIcon = styled(HiddenStateIcon)`
  left: 101.25%; top: 18.5%; width: 1.4%;
`;
const SouthCarolinaIcon = styled(StateIcon)`
  left: 85.9%;  top: 63.8%;  width: 9%;
`;
const SouthDakotaIcon = styled(StateIcon)`
  left: 45.6%;  top: 21.9%;  width: 12.6%
`;
const TennesseeIcon = styled(HiddenStateIcon)`
  left: 73.7%; top: 56.6%; width: 15.2%;
`;
const TexasIcon = styled(HiddenStateIcon)`
  left: 44.3%; top: 77.1%; width: 24.5%;
`;
const UtahIcon = styled(StateIcon)`
  left: 23.1%;  top: 38.95%;  width: 10.1%;
`;
const VermontIcon = styled(HiddenStateIcon)`
  left: 96.8%; top: 9.2%; width: 3.2%;
`;
const VirginiaIcon = styled(StateIcon)`
  left: 86.5%;  top: 45%;  width: 14.5%;
`;
const WestVirginiaIcon = styled(StateIcon)`
  left: 84.4%;  top: 40%;  width: 8.1%;
`;
const WashingtonIcon = styled(HiddenStateIcon)`
  left: 11.0%; top: 1.4%; width: 12.0%;
`;
const WisconsinIcon = styled(StateIcon)`
  left: 64.4%;  top: 19.6%;  width: 8.7%;
`;
const WyomingIcon = styled(HiddenStateIcon)`
  left: 32.3%; top: 26.1%; width: 12.7%;
`;

// Checkout Menu
const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent black */
  z-index: 999; /* just below CourseBox */
`;

const CourseBox = styled.div`
  position: fixed;
  bottom: 20%;
  width: 30%;
  height: 60%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  z-index: 1000;
  min-width: 300px;
  max-width: 400px;

  border-radius: 20px 20px 20px 20px;

  display: flex;
  flex-direction: column;
`;

const CourseBoxTitle = styled.div`
  background-color: black;
  color: white;
  font-style: bold;
  font-size: 1.2rem;
  width: 100%;
  padding: 10px;
  
  border-radius: 12px 12px 0px 0px;
  user-select: none;
`;

const CourseBoxContent = styled.div`
  background-color: #E5E5E5;
  padding: 10px 30px 80px 30px;
  
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 10px;
  flex-grow: 1;
  user-select: none;
`;
const CourseCheckout = styled.span`
  cursor: pointer;
  color: ${props => (props.active ? "#007BFF" : "black")};
  transition: color 0.2s;
  font-size: 1.2rem;
  font-style: none;

  &:hover {
    color: #007BFF;
    font-style: bold;
  }
`;
const DurationText = styled.div`
  font-size: 0.8rem;
  color: grey;
`;

const CourseBoxCheckout = styled.div`
  width: 100%;
  color: white;
  background-color: black;
  font-style: bold;
  font-size: 1.2rem;
  padding: 20px 10px 20px 10px;
  text-align: center;
  transition: background-color 0.8s ease, color 0.8s ease;
  cursor: pointer;
  border-radius: 0px 0px 12px 12px;

  &:hover {
    background-color: #30B354;
    color: black;
  }
`;
const CourseBoxCheckout2 = styled.div`
  width: 100%;
  color: white;
  background-color: black;
  font-style: bold;
  font-size: 1.2rem;
  padding: 20px 10px 20px 10px;
  text-align: center;
  transition: background-color 0.8s ease, color 0.8s ease;
  cursor: pointer;
  border-radius: 0px 0px 12px 12px;

  &:hover {
    background-color: #FF6275;
    color: black;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 12px;
  border: none;
  color: white;
  background: transparent;
  font-size: 1.2rem;
  cursor: pointer;
`;

// Artifacts I'm too affraid to delete
const Space = styled.div`
  padding-top: 70px;
`;

const Container = styled.div`
  /* padding: 60px; */
  background-color: #f2f2f2;
`;

const CourseContainer = styled.div`
  /* box-sizing: border-box;
  padding: 60px; */
`;

const ListedCourses = styled.ul`
  column-count: 4;
  column-gap: 6vw;
  list-style-type: disc;
  margin: 0 auto; 
  padding-left: 100px;
  padding-bottom: 30px;
  text-align: left; 

  width: fit-content; 
  max-width: 100%; 

  /* Optional: Better spacing */
  li {
    break-inside: avoid;
    margin-bottom: 0.75rem;
  }

  @media (max-width: 1500px) {
    column-count: 3;
    padding-left: 135px;}

  @media (max-width: 1100px) {
    column-count: 2;
    padding-left: 130px;
    
  }

  @media (max-width: 700px) {
    column-count: 1;
    padding-left: 150px;
  }
`;

const QuickAccessCourse = styled.li`
  font-size: 1.1rem;
  transition: color 0.5 ease;
  cursor: pointer;

  &:hover {
    color: #007BFF;
    font-style: bold;
  }
`;